module.exports = __webpack_public_path__ + "img/right2.db49ad88.svg";